/* eslint-disable complexity */
import React from "react"
import { useTranslation } from "react-i18next"

import { useApiContext } from "~/api"
import { Breadcrumbs } from "~/components/Breadcrumbs/Breadcrumbs"
import { Heading } from "~/components/Heading/Heading"

import { Filter } from "./components/Filter/Filter"
import { Rubrics } from "./components/Rubrics/Rubrics"
import { Tabs } from "./components/Tabs/Tabs"
import styles from "./index.module.css"

export const List: React.FC = () => {
  const { t } = useTranslation()
  const documents = useApiContext("/documents/elements")
  const { name, items } = documents

  const isCorpDocs =
    name === "Корпоративные документы" || name === "Corporate documents" ? true : false

  // if (!items || items.length === 0) {
  //   return null
  // }

  const isYear = items && items.find((item) => item.year)
  const isRubric = items && items.find((item) => item.rubric)

  return (
    <div className="container">
      <Breadcrumbs />

      <Heading as="h2" className={styles.Title} like="h1">
        {name}
      </Heading>
      {items && items.length > 0 && (
        <>
          {isCorpDocs && (
            <div
              className={styles.Description}
              dangerouslySetInnerHTML={{ __html: t("docs.Description") }}
            />
          )}

          {!isYear && !isRubric && <Filter />}

          {isYear && !isRubric && <Tabs />}

          {isRubric && <Rubrics />}
        </>
      )}
    </div>
  )
}
